import { ApplicationSettingsReport } from '../store/schema/ApplicationSettingsReport';
import { ApplicationSettings } from '../store/schema/ApplicationSettings';

const findExtra = (arr1, arr2) => arr1.filter(key => !arr2.includes(key));
const match = (arr1, arr2) => arr1.filter(key => arr2.includes(key));

export const generateApplicationSettingsReport = (
    defaultSettings: ApplicationSettings,
    receivedSettings: ApplicationSettings,
    lastError?: string
): ApplicationSettingsReport | undefined => {
    const report = {} as ApplicationSettingsReport;
    let missingSettingsCount = 0;
    let extraSettingsCount = 0;

    const defaultGroups = Object.keys(defaultSettings);
    const receivedGroups = Object.keys(receivedSettings);

    const missingGroups = findExtra(defaultGroups, receivedGroups);
    const extraGroups = findExtra(receivedGroups, defaultGroups);
    const presentGroups = match(defaultGroups, receivedGroups);

    if (missingGroups.length) {
        report.MissingSettings = [];
        for (const group of missingGroups) {
            report.MissingSettings.push({ group, settings: ['all'] });
            missingSettingsCount += Object.keys(defaultSettings[group]).length;
        }
    }

    if (extraGroups.length) {
        report.ExtraSettings = [];
        for (const group of extraGroups) {
            const extraSettings = Object.keys(receivedSettings[group]);
            report.ExtraSettings.push({ group, settings: extraSettings });
            extraSettingsCount += Object.keys(receivedSettings[group]).length;
        }
    }

    presentGroups.forEach(group => {
        const defaultSettingKeys = Object.keys(defaultSettings[group]);
        const receivedSettingKeys = Object.keys(receivedSettings[group]);

        const missingSettings = findExtra(defaultSettingKeys, receivedSettingKeys);
        const extraSettings = findExtra(receivedSettingKeys, defaultSettingKeys);

        if (missingSettings.length) {
            report.MissingSettings = [{ group, settings: missingSettings }];
            missingSettingsCount += missingSettings.length;
        }

        if (extraSettings.length) {
            report.ExtraSettings = [{ group, settings: extraSettings }];
            extraSettingsCount += extraSettings.length;
        }
    });

    if (missingSettingsCount) {
        report.MissingSettingsCount = missingSettingsCount;
    }

    if (extraSettingsCount) {
        report.ExtraSettingsCount = extraSettingsCount;
    }

    if (lastError) {
        report.LastError = lastError;
    }

    if (missingSettingsCount || extraSettingsCount) {
        return report;
    }

    return undefined;
};

export const getNoSettingsReport = () => ({ NoSettings: true });
